import React from 'react';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import InvestmentSection from './InvestmentSection';
import LoanSection from './LoanSection';
import { Helmet } from 'react-helmet-async';
// import LiveStock  from './LiveStock';
 
const Home = () => {
  return (
    <main>
      

      <Helmet>
        {/* Basic SEO */}
        <title>Wealth Management Services in Hyderabad | Portfolio Management Services (PMS) | Financial Planning Services | Lotoswealth</title>

        <meta
          name="description"
          content="Lotoswealth provides expert Wealth Management Services, Portfolio Management Services (PMS), Financial Planning, Tax Planning, Mutual Funds, Stock Investments, Retirement Planning, Estate Planning, Asset Management, Home Loans, Car Loans, and Education Loans in Hyderabad to help individuals and families achieve their financial goals."
        />

        <meta
          name="keywords"
          content="Wealth Management Services in Hyderabad, Portfolio Management Services in Hyderabad, PMS Hyderabad, Financial Planning Services in Hyderabad, Lotoswealth, Investment Advisor Hyderabad, Financial Advisor Hyderabad, Wealth Advisor Hyderabad, Asset Management Hyderabad, Tax Planning Hyderabad, Estate Planning Hyderabad, Retirement Planning Hyderabad, FIRE Planning Hyderabad, Corporate Financial Wellness Hyderabad, Alternative Investments Hyderabad, Private Equity Hyderabad, Private Credit Hyderabad, Offshore Investments Hyderabad, Mutual Funds Hyderabad, SIP Investment Hyderabad, Stocks Investment Hyderabad, Equity Investment Hyderabad, Home Loan Hyderabad, Car Loan Hyderabad, Education Loan Hyderabad, Wealth Management India, Financial Services Hyderabad"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Lotoswealth" />
        <meta name="language" content="English" />

        <link rel="canonical" href="https://www.lotoswealth.com/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Lotoswealth" />
        <meta property="og:url" content="https://www.lotoswealth.com/" />
        <meta
          property="og:title"
          content="Wealth Management Services in Hyderabad | Lotoswealth"
        />
        <meta
          property="og:description"
          content="Expert Wealth Management, Portfolio Management Services (PMS), Financial Planning, Mutual Funds, Stock Investments, Tax Planning, Retirement Planning, Estate Planning, and Loan Advisory Services in Hyderabad."
        />
        <meta
          property="og:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Wealth Management Services in Hyderabad | Lotoswealth"
        />
        <meta
          name="twitter:description"
          content="Grow and protect your wealth with expert financial advisors in Hyderabad. Wealth Management, PMS, Financial Planning, Tax Planning, Mutual Funds, and Investment Advisory."
        />
        <meta
          name="twitter:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />
      </Helmet>
      {/* Hero Section */}
      <div className="hero-wrapper">
        
        {/* Background Video */}
        <video 
          autoPlay 
          loop 
          muted  
          playsInline 
          className="hero-bg-video"
        >
          <source src="/videos/lotoswealth.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* --- Floating Main Header Text --- */}
        <div className="hero-main-text" style={{  top: '30%' }}>
          <h4 className="animate-slide-up delay-1">Welcome to Lotoswealth</h4>
          <h2 className="animate-slide-up delay-2">We specialize in Investment, Tax Planning, Loans, and Wealth Management Services.</h2>
          <p className="hero-description mt-3 animate-slide-up delay-3">
            Empowering your financial journey with customized strategies to grow your wealth, protect your assets, and secure your future.
          </p>
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container">
          
          <div className="slanted-panel panel-1 text-white">
            <div className="panel-content">
              <h2 className="animate-slide-up delay-2">PORTFOLIO MANAGEMENT</h2>
              <ul className="text-start mb-4 fs-6 animate-slide-up delay-3">
                <li className="mb-2">Customized investment strategies</li>
                <li className="mb-2">Active portfolio monitoring</li>
                <li className="mb-2">Risk assessment & mitigation</li>
                <li className="mb-2">Regular performance reporting</li>
              </ul>
              <a href="/portfolio-management-services" className="btn btn-custom-teal animate-slide-up delay-4 hover-lift text-decoration-none d-inline-block">More Info</a>
            </div>
          </div>
 
          <div className="slanted-panel panel-2 text-dark">
            <div className="panel-content">
              <h2 className="animate-slide-up delay-3">INVESTMENTS</h2>
              <ul className="text-start mb-4 fs-6 animate-slide-up delay-4">
                <li className="mb-2">Diverse mutual fund options</li>
                <li className="mb-2">Direct equity and stocks</li>
                <li className="mb-2">Fixed income securities</li>
                <li className="mb-2">Goal-based investment plans</li>
              </ul>
              <a href="/stock-investment" className="btn btn-custom-teal animate-slide-up delay-7 hover-lift text-decoration-none d-inline-block">More Info</a>
            </div>
          </div>

          <div className="slanted-panel panel-3 text-white">
            <div className="panel-content">
              <h2 className="animate-slide-up delay-4">LOANS</h2>
              <ul className="text-start mb-4 fs-6 animate-slide-up delay-5">
                <li className="mb-2">Competitive home loan rates</li>
                <li className="mb-2">Flexible car financing</li>
                <li className="mb-2">Education loans for students</li>
                <li className="mb-2">Quick & hassle-free processing</li>
              </ul>
              <a href="/home-loan" className="btn btn-custom-teal animate-slide-up delay-7 hover-lift text-decoration-none d-inline-block">More Info</a>
            </div>
          </div>

         <div className="slanted-panel panel-4 text-white">
          <div className="panel-content">
            <h2 className="animate-slide-up delay-5">WEALTH MANAGEMENT</h2>
            <ul className="text-start mb-4 fs-6 animate-slide-up delay-6">
              <li className="mb-2">Comprehensive financial planning</li>
              <li className="mb-2">Asset allocation & protection</li>
              <li className="mb-2">Retirement & estate advisory</li>
              <li className="mb-2">High-net-worth portfolio care</li>
            </ul>
            <a href="/wealth-management" className="btn btn-custom-teal animate-slide-up delay-7 hover-lift text-decoration-none d-inline-block">More Info</a>
          </div>
        </div>

        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker">
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Seamless Infinite Scrolling */}
            <div className="ticker-item"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>

      </div>

       {/* <LiveStock /> */}

      <AboutSection />
      <ServicesSection />
      <InvestmentSection />

      <LoanSection />
    </main>
  );
};

export default Home;